import { ReactNode } from 'react'

type IModalHeaderProps = {
  title?: string | ReactNode
  handleClose: () => void
}

const ModalHeader = ({ title, handleClose }: IModalHeaderProps) => {
  return (
    <div className='modal-header'>
      <h5 className='modal-title'>{title}</h5>
      <button type='button' className='btn-close' aria-label='Close' onClick={handleClose} />
    </div>
  )
}

export default ModalHeader
